import { createTransportationConfigs, deleteTransportationConfigs, updateTransportationConfigs } from 'services/factoryAPI'
import { CancelOrderInput, CancelOrderResponse, ConfirmManualPaymentBatchInput, ConfirmManualPaymentBatchResponse, ConfirmManualPaymentInput, ConfirmManualPaymentResponse, ConfirmTransportResponse, CreateOrderTransactionInput, CreateOrderTransactionResponse, CreateTransportationInput, CreateTransportationResponse, DeleteTransportationInput, DeleteTransportationResponse, ExportOrderTransaferInput, ExportOrderTransaferResponse, FactoryCreateOrderInput, FactoryCreateOrderResponse, FactoryUpdateOrderInput, FactoryUpdateOrderResponse, GetDataOrderListRequest, GetDataOrderListResponse, GetDataThaipostResponse, GetLoadNewOrderSkuInput, GetLoadNewOrderSkuResponse, GetOrderCancelResponse, GetOrderCompleteResponse, GetOrderDetailInput, GetOrderDetailResponse, GetOrderProductSkuListInput, GetOrderProductSkuListResponse, GetOrderproductskuNewOrderInput, GetOrderproductskuNewOrderResponse, GetOrderWaitingRefundResponse, GetPendingSkuResponse, GetWaitingShipResponse, InputConfirmTransport, LotTransactionDetailInput, LotTransactionDetailResponse, MakeappointmentInput, MakeappointmentResponse, MakeOrderConfirmInput, NewOrderResponse, OlderLotTransactionInput, OlderLotTransactionResponse, OrderDistributedListResponse, OrderDistributedResponse, OrderTransactionInput, PriceTransportationInput, PricetransportationResponse, refundApproveInput, refundApproveResponse, SendProductionExportResponse, SubmitNewOrderInput, SubmitNewOrderResponse, UpdateApproveRequestCancelInput, UpdateApproveRequestCancelResponse, UpdateCapacityInput, UpdateCapacityResponse, UpdateDeleteRequestCancelInput, UpdateDeleteRequestCancelResponse, UpdateOrderCompleteInput, UpdateOrderCompleteResponse, UpdateOrderTransactionInput, UpdateOrderTransactionResponse, UpdateManualPaymentResponse, UpdateTransportationInput, UpdateTransportationResponse, GetRepeatOrdertResponse, GetOrderRepeatInput, refundPaymentResponse, refundPaymentInput, DetailRefundResponse, LoadTaxInvoiceListInput, LoadTaxInvoiceListResponse, CreateTaxInvoiceResponse, CreateTaxInvoiceInput, DeleteTaxInvoiceResponse, DeleteTaxInvoiceInput, updateReadOrderResponse, updateReadOrderInput, getTaxInvoiceByOrderIdResponse, LoadTaxInvoiceDataInput, LoadTaxInvoiceDataResponse, getTaxInvoiceByOrderIdInput, GetOrderTracksRequest, GetOrderTracksResponse, UpdateTrackingPrintRequest, UpdateTrackingPrintResponse, GetTransportBrandsResponse, RevertManualOrderResponse, RevertManualOrderInput } from 'services/interface'

import { getNewOrder, getWaitingShip, postMakeappointment, getOrderComplete, getPendingsku, getOrderCancel, getOrderProductSkuList, postUpdateCapacity, submitNewOrderInput, getInprocess, getDataThaipost, getOrderWaitingRefund, updateApproveRequestCancel, updateDeleteRequestCancel, getOrderproductskuNewOrder, postMakeOrderConfirm, getLoadNewOrderSku, createOrderTransaction, getOrderDistributed, getLotTransactionDetail, getOlderLotTransaction, getExportOrderTransafer, getOrderDistributedList, rollbackOrderTransaction, getOrderPayment, createOrderAdmin, confirmManualPayment, confirmManualPaymentBatch, getDataNewOrder, getOrderDetail, confirmOrderTransport, updateOrderAdmin, updateOrderComplete, getPriceTransportation, cancelOrder, getSendProductionExport, refundApprove, updateManualPayment, getRepeatOrderRetail, refundPayment, getDetailRefund, loadTaxInvoiceList, createTaxInvoice, deleteTaxInvoice, updateReadOrder, getTaxInvoiceByOrderId, loadTaxInvoiceData, getOrderTracks, updateTrackingPrint, getTransportBrands, revertManualOrder, confirmOrderShipped } from 'services/ordersApi'
import { UseQueryResult, useQuery, UseMutationResult, useMutation, useQueryClient, QueryClient } from '@tanstack/react-query';
import { CREDIT_BALANCE_QUERY_KEY, COD_CREDIT_INFO_QUERY_KEY } from 'hooks/useFactoryCredit';
import { CREDIT_TRANSACTIONS_QUERY_KEY } from 'hooks/useFactoryCreditTransactions';

const queryClient = new QueryClient();

// Get new orders
export const useGetNewOrders = (): UseQueryResult<NewOrderResponse, Error> => {
  return useQuery<NewOrderResponse, Error>({
    queryKey: ['newOrders'],
    queryFn: getNewOrder,
    // staleTime: 1000 * 60 * 60 * 24,
  });
};

// Get order payment
export const useGetOrderPayment = (): UseQueryResult<NewOrderResponse, Error> => {
  return useQuery<NewOrderResponse, Error>({
    queryKey: ['ordersPayment'],
    queryFn: getOrderPayment,
    staleTime: 1000 * 60 * 60 * 24,
  });
};

// Get orders in process
export const useGetOrdersInprocess = (): UseQueryResult<NewOrderResponse, Error> => {
  return useQuery<NewOrderResponse, Error>({
    queryKey: ['getOrderInprocess'],
    queryFn: getInprocess,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Get waiting shipment
export const useGetWaitingShip = (): UseQueryResult<GetWaitingShipResponse, Error> => {
  return useQuery<GetWaitingShipResponse, Error>({
    queryKey: ['waitingShip'],
    queryFn: getWaitingShip,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Get completed orders
export const useGetOrderComplete = (): UseQueryResult<GetOrderCompleteResponse, Error> => {
  return useQuery<GetOrderCompleteResponse, Error>({
    queryKey: ['orderComplete'],
    queryFn: getOrderComplete,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Get orders waiting for refund
export const useGetOrderWaitingRefund = (): UseQueryResult<GetOrderWaitingRefundResponse, Error> => {
  return useQuery<GetOrderWaitingRefundResponse, Error>({
    queryKey: ['orderWaitingRefund'],
    queryFn: getOrderWaitingRefund,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Get canceled orders
export const useGetOrderCancel = (): UseQueryResult<GetOrderCancelResponse, Error> => {
  return useQuery<GetOrderCancelResponse, Error>({
    queryKey: ['orderCancel'],
    queryFn: getOrderCancel,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Get pending SKUs
export const useGetPendingsku = (): UseQueryResult<GetPendingSkuResponse, Error> => {
  return useQuery<GetPendingSkuResponse, Error>({
    queryKey: ['pendingsku'],
    queryFn: getPendingsku,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Submit make appointment
export const useSubmitMakeappointment = (): UseMutationResult<
  MakeappointmentResponse,
  Error,
  MakeappointmentInput,
  unknown
> => {
  return useMutation<MakeappointmentResponse, Error, MakeappointmentInput, unknown>({
    mutationFn: postMakeappointment,
  });
};

// Update approve request cancel
export const useUpdateApproveRequestCancel = (): UseMutationResult<
  UpdateApproveRequestCancelResponse,
  Error,
  UpdateApproveRequestCancelInput,
  unknown
> => {
  return useMutation<UpdateApproveRequestCancelResponse, Error, UpdateApproveRequestCancelInput, unknown>({
    mutationFn: updateApproveRequestCancel,
  });
};

// Update delete request cancel
export const useUpdateDeleteRequestCancel = (): UseMutationResult<
  UpdateDeleteRequestCancelResponse,
  Error,
  UpdateDeleteRequestCancelInput,
  unknown
> => {
  return useMutation<UpdateDeleteRequestCancelResponse, Error, UpdateDeleteRequestCancelInput, unknown>({
    mutationFn: updateDeleteRequestCancel,
  });
};

// Get order product SKU list
export const useGetOrderProductSkuList = (
  input: GetOrderProductSkuListInput
): UseQueryResult<GetOrderProductSkuListResponse, Error> => {
  return useQuery<GetOrderProductSkuListResponse, Error>({
    queryKey: ['orderProductSkuList', input.start_date, input.end_date],
    queryFn: () => getOrderProductSkuList(input),
    staleTime: 1000 * 60 * 60 * 24,
  });
};

// Get load new orders
export const useGetLoadNewOrders = (
  input: GetDataOrderListRequest
): UseQueryResult<GetDataOrderListResponse, Error> => {
  // console.log(['orderDataNewOrder', input.order_date, input.agent_id, input.search, input.status, input.offset, input.limit]);
  return useQuery<GetDataOrderListResponse, Error>({
    queryKey: ['orderDataNewOrder', input.order_date, input.agent_id, input.factory_id, input.search, input.status, input.offset, input.limit, input.sort_by, input.sort_direction],
    queryFn: () => getDataNewOrder(input),
    // staleTime: 1000 * 60 * 10,
  });
};

/** Input สำหรับโหลด order tracks (ไม่รวม shipment_type — ใช้แยก hook ตามประเภท) */
export type GetOrderTracksInput = Omit<GetOrderTracksRequest, "shipment_type">;

// โหลดรายการ Track การจัดส่งทั้งหมด (Factory) - ปริ้น Label ขนส่ง
export const useGetOrderTracks = (
  input: GetOrderTracksRequest
): UseQueryResult<GetOrderTracksResponse, Error> => {
  return useQuery<GetOrderTracksResponse, Error>({
    queryKey: ['orderTracks', input.shipment_type, input.order_code, input.brand_code, input.brand_codes, input.brand_id, input.tracking_number, input.is_print, input.ref_name, input.ref_telephone, input.page_number, input.row_per_page, input.offset, input.limit],
    queryFn: () => getOrderTracks(input),
  });
};

// โหลดรายการ Track แบบส่งกับแบรนด์ (shipment_type: bangbow) — เรียกแยกในหน้า ปริ้น Label
export const useGetOrderTracksBangbow = (
  input: GetOrderTracksInput
): UseQueryResult<GetOrderTracksResponse, Error> => {
  return useQuery<GetOrderTracksResponse, Error>({
    queryKey: ['orderTracksBangbow', input.order_code, input.brand_code, input.brand_codes, input.brand_id, input.tracking_number, input.is_print, input.ref_name, input.ref_telephone, input.page_number, input.row_per_page, input.offset, input.limit],
    queryFn: () => getOrderTracks({ ...input, shipment_type: "bangbow" }),
  });
};

// โหลดรายการ Track แบบส่งเอง (shipment_type: self) — เรียกแยกในหน้า ปริ้น Label
export const useGetOrderTracksSelf = (
  input: GetOrderTracksInput
): UseQueryResult<GetOrderTracksResponse, Error> => {
  return useQuery<GetOrderTracksResponse, Error>({
    queryKey: ['orderTracksSelf', input.order_code, input.tracking_number, input.is_print, input.ref_name, input.ref_telephone, input.page_number, input.row_per_page, input.offset, input.limit],
    queryFn: () => getOrderTracks({ ...input, shipment_type: "self" }),
  });
};

// อัปเดตสถานะพิมพ์ (Tracking Print) — มาร์กว่าพิมพ์แล้ว
export const useUpdateTrackingPrint = (): UseMutationResult<
  UpdateTrackingPrintResponse,
  Error,
  UpdateTrackingPrintRequest,
  unknown
> => {
  return useMutation<UpdateTrackingPrintResponse, Error, UpdateTrackingPrintRequest, unknown>({
    mutationFn: updateTrackingPrint,
  });
};

// ดึงรายการ Transport Brand สำหรับ dropdown (GET /factory/orders/transport-brands)
export const useGetTransportBrands = (): UseQueryResult<GetTransportBrandsResponse, Error> => {
  return useQuery<GetTransportBrandsResponse, Error>({
    queryKey: ['transportBrands'],
    queryFn: getTransportBrands,
    staleTime: 1000 * 60 * 10, // 10 นาที
  });
};

// Update capacity
export const useUpdateCapacity = (): UseMutationResult<
  UpdateCapacityResponse,
  Error,
  UpdateCapacityInput,
  unknown
> => {
  return useMutation<UpdateCapacityResponse, Error, UpdateCapacityInput, unknown>({
    mutationFn: postUpdateCapacity,
  });
};

// Submit new order
export const useSubmitNewOrder = (): UseMutationResult<
  SubmitNewOrderResponse,
  Error,
  SubmitNewOrderInput,
  unknown
> => {
  return useMutation<SubmitNewOrderResponse, Error, SubmitNewOrderInput, unknown>({
    mutationFn: submitNewOrderInput,
  });
};

// Get data from Thai post
export const useGetDataThaipost = (): UseQueryResult<GetDataThaipostResponse, Error> => {
  return useQuery<GetDataThaipostResponse, Error>({
    queryKey: ['getDataThaipost'],
    queryFn: getDataThaipost,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

// Get order product SKU for new order
export const useGetOrderproductskuNewOrder = (
  input: GetOrderproductskuNewOrderInput
): UseQueryResult<GetOrderproductskuNewOrderResponse, Error> => {
  return useQuery<GetOrderproductskuNewOrderResponse, Error>({
    queryKey: ['getOrderproductskuNewOrder', input.limit, input.offset],
    queryFn: () => getOrderproductskuNewOrder(input),
    // staleTime: 1000 * 60 * 60 * 24,
  });
};
export const useSubmitMakeOrderConfirm = (): UseMutationResult<
  MakeappointmentResponse,
  Error,
  MakeOrderConfirmInput,
  unknown
> => {
  return useMutation<MakeappointmentResponse, Error, MakeOrderConfirmInput, unknown>({
    mutationFn: (input: MakeOrderConfirmInput) => postMakeOrderConfirm(input),
  })
}

export const useCreateOrderTransaction = (): UseMutationResult<
  CreateOrderTransactionResponse,
  Error,
  CreateOrderTransactionInput,
  unknown
> => {
  return useMutation<CreateOrderTransactionResponse, Error, CreateOrderTransactionInput, unknown>({
    mutationFn: (input: CreateOrderTransactionInput) => createOrderTransaction(input),
  })
}


export const useUpdateOrderTransaction = (): UseMutationResult<
  UpdateOrderTransactionResponse,
  Error,
  UpdateOrderTransactionInput,
  unknown
> => {
  return useMutation<UpdateOrderTransactionResponse, Error, UpdateOrderTransactionInput, unknown>({
    mutationFn: (input: UpdateOrderTransactionInput) => rollbackOrderTransaction(input),
  })
}


export const useGetLoadNewOrderSku = (
  input: GetLoadNewOrderSkuInput
): UseQueryResult<GetLoadNewOrderSkuResponse, Error> => {
  return useQuery<GetLoadNewOrderSkuResponse, Error>({
    queryKey: ['getLoadNewOrderSku', input.limit, input.offset],
    queryFn: () => getLoadNewOrderSku(input),
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })
}

export const useGetOrderDistributed = (input: string): UseQueryResult<OrderDistributedResponse, Error> => {
  return useQuery<OrderDistributedResponse, Error>({
    queryKey: ['getOrderDistributed', input],
    queryFn: () => getOrderDistributed(input),
  })
}

export const useGetOrderDistributedList = (
  input: OrderTransactionInput
): UseQueryResult<OrderDistributedListResponse, Error> => {
  return useQuery<OrderDistributedListResponse, Error>({
    queryKey: ['getOrderDistributedList', input.limit, input.offset, input.search, input.tran_date],
    queryFn: () => getOrderDistributedList(input),
  })
}

export const useGetLotTransactionDetail = (
  input: LotTransactionDetailInput
): UseQueryResult<LotTransactionDetailResponse, Error> => {
  return useQuery<LotTransactionDetailResponse, Error>({
    queryKey: ['orderLotTransactionDetail', input.dc_id, input.province_id, input.lot_no, input.date_start, input.date_end, input.limit, input.offset, input.search, input.status_list],
    queryFn: () => getLotTransactionDetail(input),
  })
}

export const useGetOlderLotTransaction = (
  input: OlderLotTransactionInput
): UseQueryResult<OlderLotTransactionResponse, Error> => {
  return useQuery<OlderLotTransactionResponse, Error>({
    queryKey: ['orderLotTransaction', input.date_start, input.date_end, input.limit, input.offset, input.search, input.status_list],
    queryFn: () => getOlderLotTransaction(input),
  })
}

export const useGetExportOrderTransafer = (
  input: ExportOrderTransaferInput
): UseQueryResult<ExportOrderTransaferResponse, Error> => {
  return useQuery<ExportOrderTransaferResponse, Error>({
    queryKey: ['ExportOrderTransfer', input.search, input.limit, input.offset],
    queryFn: () => getExportOrderTransafer(input),
    staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useGetCompleteOrder = (
  input: GetOrderproductskuNewOrderInput
): UseQueryResult<GetOrderproductskuNewOrderResponse, Error> => {
  return useQuery<GetOrderproductskuNewOrderResponse, Error>({
    queryKey: ['getCompleteOrder', input.sort_by, input.limit, input.offset],
    queryFn: () => getOrderproductskuNewOrder(input),
  })
}

export const useGetCancelOrder = (
  input: GetOrderproductskuNewOrderInput
): UseQueryResult<GetOrderproductskuNewOrderResponse, Error> => {
  return useQuery<GetOrderproductskuNewOrderResponse, Error>({
    queryKey: ['getCancelOrder', input.sort_by, input.limit, input.offset],
    queryFn: () => getOrderproductskuNewOrder(input),
  })
}
export const useCreateOrderAdmin = (): UseMutationResult<
  FactoryCreateOrderResponse,
  Error,
  FactoryCreateOrderInput,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation<FactoryCreateOrderResponse, Error, FactoryCreateOrderInput, unknown>({
    mutationFn: (input: FactoryCreateOrderInput) => createOrderAdmin(input),
    onSuccess: (res) => {
      // สร้าง COD จองโควต้าแล้ว — รีเฟรชการ์ดเครดิตทันที (แม้ socket มาช้า/หลุด)
      if (res?.status === "success") {
        void queryClient.invalidateQueries({ queryKey: [CREDIT_BALANCE_QUERY_KEY] });
        void queryClient.invalidateQueries({ queryKey: [COD_CREDIT_INFO_QUERY_KEY] });
        void queryClient.invalidateQueries({ queryKey: [CREDIT_TRANSACTIONS_QUERY_KEY] });
      }
    },
  })
}

export const useUpdateOrderAdmin = (): UseMutationResult<
  FactoryUpdateOrderResponse,
  Error,
  FactoryUpdateOrderInput,
  unknown
> => {
  return useMutation<FactoryUpdateOrderResponse, Error, FactoryUpdateOrderInput, unknown>({
    mutationFn: (input: FactoryUpdateOrderInput) => updateOrderAdmin(input),
  })
}

export const useCancelOrder = (): UseMutationResult<
  CancelOrderResponse,
  Error,
  CancelOrderInput,
  unknown
> => {
  return useMutation<CancelOrderResponse, Error, CancelOrderInput, unknown>({
    mutationFn: (input: CancelOrderInput) => cancelOrder(input),
  })
}

export const useConfirmManualPayment = (): UseMutationResult<
  ConfirmManualPaymentResponse,
  Error,
  ConfirmManualPaymentInput,
  unknown
> => {
  return useMutation<ConfirmManualPaymentResponse, Error, ConfirmManualPaymentInput, unknown>({
    mutationFn: (input: ConfirmManualPaymentInput) => confirmManualPayment(input),
  })
}

export const useConfirmManualPaymentBatch = (): UseMutationResult<
  ConfirmManualPaymentBatchResponse,
  Error,
  ConfirmManualPaymentBatchInput,
  unknown
> => {
  return useMutation<
    ConfirmManualPaymentBatchResponse,
    Error,
    ConfirmManualPaymentBatchInput,
    unknown
  >({
    mutationFn: (input: ConfirmManualPaymentBatchInput) =>
      confirmManualPaymentBatch(input),
  })
}

export const useUpdateManualPayment = (): UseMutationResult<
  UpdateManualPaymentResponse,
  Error,
  ConfirmManualPaymentInput,
  unknown
> => {
  return useMutation<UpdateManualPaymentResponse, Error, ConfirmManualPaymentInput, unknown>({
    mutationFn: (input: ConfirmManualPaymentInput) => updateManualPayment(input),
  })
}

export const useRevertManualOrder = (): UseMutationResult<
  RevertManualOrderResponse,
  Error,
  RevertManualOrderInput,
  unknown
> => {
  return useMutation<RevertManualOrderResponse, Error, RevertManualOrderInput, unknown>({
    mutationFn: (input: RevertManualOrderInput) => revertManualOrder(input),
  })
}


export const useGetOrderDetail = (): UseMutationResult<
  GetOrderDetailResponse,
  Error,
  GetOrderDetailInput,
  unknown
> => {
  return useMutation<GetOrderDetailResponse, Error, GetOrderDetailInput, unknown>({
    mutationFn: (input: GetOrderDetailInput): Promise<GetOrderDetailResponse> => getOrderDetail(input)
  })
}

export const useConfirmOrderTransport = (): UseMutationResult<
  ConfirmTransportResponse,
  Error,
  InputConfirmTransport,
  unknown
> => {
  return useMutation<ConfirmTransportResponse, Error, InputConfirmTransport, unknown>({
    mutationFn: (input: InputConfirmTransport): Promise<ConfirmTransportResponse> => confirmOrderTransport(input),
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: ["getOrderDistributed"],
        type: "active",
      });
    }
  })
}

export const useUpdateOrderComplete = (): UseMutationResult<
  UpdateOrderCompleteResponse,
  Error,
  UpdateOrderCompleteInput,
  unknown
> => {
  return useMutation<UpdateOrderCompleteResponse, Error, UpdateOrderCompleteInput, unknown>({
    mutationFn: (input: UpdateOrderCompleteInput): Promise<UpdateOrderCompleteResponse> => updateOrderComplete(input)
  })
}

export const useGetPriceTransportation = (
  input: PriceTransportationInput
): UseQueryResult<PricetransportationResponse, Error> => {
  return useQuery<PricetransportationResponse, Error>({
    queryKey: ['getPriceTransportation', input.total_price, input.transport_type],
    queryFn: () => getPriceTransportation(input),
    // staleTime: 1000 * 60 * 60 * 24, 
  })
}

export const useMutatePriceTransportation = (): UseMutationResult<
  PricetransportationResponse,
  Error,
  PriceTransportationInput,
  unknown
> => {
  return useMutation<PricetransportationResponse, Error, PriceTransportationInput, unknown>({
    mutationFn: (input: PriceTransportationInput): Promise<PricetransportationResponse> => getPriceTransportation(input)
  })
}

export const useUpdateTransportationConfigs = (): UseMutationResult<
  UpdateTransportationResponse,
  Error,
  UpdateTransportationInput,
  unknown
> => {
  return useMutation<UpdateTransportationResponse, Error, UpdateTransportationInput, unknown>({
    mutationFn: (input: UpdateTransportationInput): Promise<UpdateTransportationResponse> => updateTransportationConfigs(input)
  })
}

export const useDeleteTransportationConfigs = (): UseMutationResult<
  DeleteTransportationResponse,
  Error,
  DeleteTransportationInput,
  unknown
> => {
  return useMutation<DeleteTransportationResponse, Error, DeleteTransportationInput, unknown>({
    mutationFn: (input: DeleteTransportationInput): Promise<DeleteTransportationResponse> => deleteTransportationConfigs(input)
  })
}

export const useGetSendProductionExport = (): UseQueryResult<SendProductionExportResponse, Error> => {
  return useQuery<SendProductionExportResponse, Error>({
    queryKey: ['getSendProductExport'],
    queryFn: () => getSendProductionExport(),
    staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useGetRepeatOrderRetail = (): UseMutationResult<
  GetOrderDetailResponse,
  Error,
  GetOrderRepeatInput,
  unknown
> => {
  return useMutation<GetOrderDetailResponse, Error, GetOrderRepeatInput, unknown>({
    mutationFn: (input: GetOrderRepeatInput): Promise<GetOrderDetailResponse> => getRepeatOrderRetail(input)
  })
}

export const useRefundApprove = (): UseMutationResult<
  refundApproveResponse,
  Error,
  refundApproveInput,
  unknown
> => {
  return useMutation<refundApproveResponse, Error, refundApproveInput, unknown>({
    mutationFn: (input: refundApproveInput): Promise<refundApproveResponse> => refundApprove(input)
  })
}

export const useRefundPayment = (): UseMutationResult<
  refundPaymentResponse,
  Error,
  refundPaymentInput,
  unknown
> => {
  return useMutation<refundPaymentResponse, Error, refundPaymentInput, unknown>({
    mutationFn: (input: refundPaymentInput): Promise<refundPaymentResponse> => refundPayment(input)
  })
}

export const useDetailRefundList = (): UseMutationResult<
  DetailRefundResponse,
  Error,
  string,
  unknown
> => {
  return useMutation<DetailRefundResponse, Error, string, unknown>({
    mutationFn: (input: string): Promise<DetailRefundResponse> => getDetailRefund(input)
  })
}

//การคืนเงิน getDetailRefund useQuery เพราะต้องการให้โหลดข้อมูลใหม่ทุกครั้งที่เปิด modal โดยใช้ useMutation เพราะต้องการให้โหลดข้อมูลเมื่อมีการเรียกใช้ฟังก์ชันเท่านั้น ไม่ได้โหลดอัตโนมัติเมื่อ component ถูก mount
export const useDetailRefundListQuery = (
  orderId: string,
  enabled: boolean
): UseQueryResult<DetailRefundResponse, Error> => {
  return useQuery<DetailRefundResponse, Error>({
    queryKey: ['detailRefund', orderId],
    queryFn: () => getDetailRefund(orderId),
    enabled: enabled, // เปิดการโหลดข้อมูลเมื่อ enabled เป็น true
    refetchOnWindowFocus: false, // ไม่โหลดซ้ำเมื่อกลับมาที่หน้าต่าง
  })
}

export const useLoadTaxInvoiceList = (
  input: LoadTaxInvoiceListInput
): UseQueryResult<LoadTaxInvoiceListResponse, Error> => {
  return useQuery<LoadTaxInvoiceListResponse, Error>({
    queryKey: ['loadTaxInvoiceList', input.customer_id, input.factory_id],
    queryFn: () => loadTaxInvoiceList(input),
  })
}

//useLoadTaxInvoiceList mutation
export const useLoadTaxInvoiceListMutation = (): UseMutationResult<
  LoadTaxInvoiceListResponse,
  Error,
  LoadTaxInvoiceListInput,
  unknown
> => {
  return useMutation<LoadTaxInvoiceListResponse, Error, LoadTaxInvoiceListInput, unknown>({
    mutationFn: (input: LoadTaxInvoiceListInput): Promise<LoadTaxInvoiceListResponse> => loadTaxInvoiceList(input)
  })
}

export const useCreateTaxInvoice = (): UseMutationResult<
  CreateTaxInvoiceResponse,
  Error,
  CreateTaxInvoiceInput,
  unknown
> => {
  return useMutation<CreateTaxInvoiceResponse, Error, CreateTaxInvoiceInput, unknown>({
    mutationFn: (input: CreateTaxInvoiceInput): Promise<CreateTaxInvoiceResponse> => createTaxInvoice(input)
  })
}

export const useDeleteTaxInvoice = (): UseMutationResult<
  DeleteTaxInvoiceResponse,
  Error,
  DeleteTaxInvoiceInput,
  unknown
> => {
  return useMutation<DeleteTaxInvoiceResponse, Error, DeleteTaxInvoiceInput, unknown>({
    mutationFn: (input: DeleteTaxInvoiceInput): Promise<DeleteTaxInvoiceResponse> => deleteTaxInvoice(input)
  })
}

export const useUpdateReadOrder = (): UseMutationResult<
  updateReadOrderResponse,
  Error,
  updateReadOrderInput,
  unknown
> => {
  return useMutation<updateReadOrderResponse, Error, updateReadOrderInput, unknown>({
    mutationFn: (input: updateReadOrderInput): Promise<updateReadOrderResponse> => updateReadOrder(input)
  })
}

export const useGetTaxInvoiceByOrderId = (): UseMutationResult<
  getTaxInvoiceByOrderIdResponse,
  Error,
  getTaxInvoiceByOrderIdInput,
  unknown
> => {
  return useMutation<getTaxInvoiceByOrderIdResponse, Error, getTaxInvoiceByOrderIdInput, unknown>({
    mutationFn: (input: getTaxInvoiceByOrderIdInput): Promise<getTaxInvoiceByOrderIdResponse> => getTaxInvoiceByOrderId(input)
  })
}

export const useTaxInvoiceDataList = (): UseMutationResult<
  LoadTaxInvoiceListResponse,
  Error,
  LoadTaxInvoiceListInput,
  unknown
> => {
  return useMutation<LoadTaxInvoiceListResponse, Error, LoadTaxInvoiceListInput, unknown>({
    mutationFn: (input: LoadTaxInvoiceListInput): Promise<LoadTaxInvoiceListResponse> => loadTaxInvoiceList(input)
  })
}

export const useLoadTaxInvoiceData = (
  input: LoadTaxInvoiceDataInput
): UseQueryResult<LoadTaxInvoiceDataResponse, Error> => {
  return useQuery<LoadTaxInvoiceDataResponse, Error>({
    queryKey: ['loadTaxInvoiceData',
      input.customer_id,
      input.factory_id,
      input.start_date,
      input.end_date,
      input.is_active,
      input.limit,
      input.offset,
      input.search
    ],
    queryFn: () => loadTaxInvoiceData(input),
  })
}


export const useConfirmOrderShipped = (): UseMutationResult<
  any,
  Error,
  { order_id: string },
  unknown
> => {
  return useMutation<any, Error, { order_id: string }, unknown>({
    mutationFn: (input: { order_id: string }): Promise<any> => confirmOrderShipped(input)
  })
}
